module.exports = __webpack_public_path__ + "img/2.842b76f0.jpg";